export default function HeroSection() {
  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="hero" className="relative min-h-[720px] md:min-h-[800px] flex items-center overflow-hidden bg-background-50">
      {/* Subtle warm gradient background */}
      <div className="absolute inset-0">
        <div className="absolute top-0 right-0 w-1/2 h-full bg-gradient-to-l from-background-100/80 to-transparent" />
        <div className="absolute bottom-0 left-0 w-full h-1/3 bg-gradient-to-t from-background-100/40 to-transparent" />
      </div>

      {/* Content */}
      <div className="relative z-10 w-full px-4 md:px-8 lg:px-12 py-20 md:py-28">
        <div className="max-w-4xl">
          {/* Badge */}
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-accent-100 rounded-full border border-accent-200 mb-8">
            <span className="w-2 h-2 rounded-full bg-accent-500" />
            <span className="text-sm font-medium text-accent-700">
              仙台のクリエイティブパートナー
            </span>
          </div>

          {/* Title — red accent removed, now uses foreground for better readability */}
          <h1 className="font-heading font-extrabold text-4xl md:text-6xl lg:text-7xl text-foreground-950 leading-tight mb-6 tracking-tight">
            <span className="block">Webもデザインも</span>
            <span className="block">事務作業も</span>
            <span className="block">全部お任せください</span>
          </h1>

          {/* Subtitle */}
          <p className="text-base md:text-lg text-foreground-600 leading-relaxed max-w-2xl mb-10">
            ヴェリテは仙台市青葉区を拠点とする、Web制作・デザイン印刷・動画制作・BPO事務サポートの総合クリエイティブカンパニーです。地域の中小企業にとって、気軽に頼れる制作パートナーとして活動しています。
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4">
            <button
              onClick={() => scrollTo('contact')}
              className="px-8 py-4 bg-primary-500 text-background-50 font-semibold rounded-full hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer"
            >
              無料相談はこちら
            </button>
            <button
              onClick={() => scrollTo('services')}
              className="px-8 py-4 bg-transparent text-foreground-700 font-semibold rounded-full border border-foreground-300 hover:border-primary-400 hover:text-primary-500 transition-all whitespace-nowrap cursor-pointer"
            >
              事業内容を見る
            </button>
          </div>
        </div>

        {/* Logo accent on right — very subtle */}
        <div className="hidden lg:block absolute right-12 top-1/2 -translate-y-1/2 opacity-[0.03]">
          <img
            src="https://storage.readdy-site.link/project_files/d7d29402-29c9-4a04-95fb-46dc6629671e/3729bbb1-4e17-4f2d-a1c0-8e0a08152d3a_compressed_CleanShot-2026-07-03-at-19.30.432x.webp"
            alt=""
            className="w-80 h-auto object-contain"
          />
        </div>
      </div>
    </section>
  );
}